import {UyapRequest} from "./UyapRequest";

export interface AdliyelerTalep {
    ilKodu: number|string
}

export type AdliyelerCevap = AdliyelerRow[];

export interface AdliyelerRow {
    gayriMenkulIcraDairesiSayisi: number,
    bankaIcraDairesiSayisi: number,
    adliyeBirimID: string,
    adliyeIsmi: string,
    tevziBelirlemeKriteri: number,
    kayitVar: boolean
}

export default class Adliyeler extends UyapRequest<AdliyelerTalep, AdliyelerCevap> {
    delayTime = 0;

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Adliyeler sorgulanıyor...";
    }

    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "adliyeler_" + this.talepData.ilKodu
        };
    }

    getMockResponse(): any {
        return [{"gayriMenkulIcraDairesiSayisi":1,"bankaIcraDairesiSayisi":0,"adliyeBirimID":"1005433","adliyeIsmi":"Aliağa Adliye","tevziBelirlemeKriteri":0,"kayitVar":false},{"gayriMenkulIcraDairesiSayisi":1,"bankaIcraDairesiSayisi":0,"adliyeBirimID":"1006986","adliyeIsmi":"Bayındır Adliye","tevziBelirlemeKriteri":0,"kayitVar":false},{"gayriMenkulIcraDairesiSayisi":1,"bankaIcraDairesiSayisi":0,"adliyeBirimID":"1001833","adliyeIsmi":"Bergama Adliye","tevziBelirlemeKriteri":0,"kayitVar":false}];
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'icraTakipAdliyeler.ajx';
    }

    /**
     * UYAP bu uc noktada hatayi HTTP 200 + `{"type":"error","message":...}` GOVDESIYLE
     * bildiriyor; `run()` bunu reject ETMIYOR, cunku oradaki kapi `error` + `errorCode`
     * ikilisini ariyor (UyapRequest.ts). Govde oldugu gibi gecince cagiran katman dizi
     * bekledigi yerde nesne buluyor: TakipBilgileriForm'da il secilip istek gidiyor ama
     * adliye listesi BOS kaliyor ve hicbir yerde sebep yazmiyor.
     *
     * Kardes uc nokta `GetIbanListesi.parse` ayni korumayi tasiyor; burasi eksikti.
     * Cevabin dizi olmadigi her durumda UYAP'in kendi mesajiyla reddediliyor: boylece
     * hata bir ust katmanda gorunur oluyor ve bozuk govde onbellege de yazilmiyor
     * (`setCachedItem` yalnizca parse basarili olunca calisiyor).
     */
    async parse(data: any): Promise<AdliyelerCevap> {
        if (!Array.isArray(data))
            return Promise.reject(new Error(data?.message || "UYAP adliye listesini döndürmedi."));
        return data;
    }
}
